export default __webpack_public_path__ + "static/media/customApp.67c640e1.png";